import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import * as XLSX from 'xlsx';
@Injectable({
  providedIn: 'root'
})
export class FilesService {

  constructor(private http: HttpClient) { }

  async uploadAndDownloadXML(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    const newFile = await lastValueFrom<any>(this.http.post(`${environment.apiUrl}/files/upload`, formData, { responseType: 'blob' }));
    saveAs(newFile, `${file.name.split('.xml')[0]}_modified_${new Date().getTime()}.xml`);
  }


    createExcelFromDeclarationsTable(data: any) {
      const transformedData = data.map((declaration: any) => ({
        Modelo: declaration.name,
        'Código cliente': declaration.client.code,
        'Código aplicación': declaration.application.code,
        Cliente: declaration.client.name,
        'Presentación': declaration.presentationType,
        Fase: `${(() => {
          const idx = declaration.tasks.findIndex((t: any) => t !== 'FINISHED' && t !== 'BLOCKED');
          return idx >= 0 ? idx + 1 : declaration.tasks.length;
        })()}/${declaration.tasks.length}`,
        Responsable: declaration.responsible?.name,
        Ejecutor: declaration.executor,
        Comentarios: declaration.observations ? 'Si' : 'No',
        'Cuenta bancaria': declaration.bankAccount,
        'Importe declaración': declaration.importeDeclaracion ?? '',
        'Individual o conjunta': declaration.individualOConjunta ?? '',
      }));
  
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(transformedData);
  
      worksheet['A1'].v = 'Modelo';
      worksheet['B1'].v = 'Código cliente';
      worksheet['C1'].v = 'Código aplicación';
      worksheet['D1'].v = 'Cliente';
      worksheet['E1'].v = 'Presentación';
      worksheet['F1'].v = 'Fase';
      worksheet['G1'].v = 'Responsable';
      worksheet['H1'].v = 'Ejecutor';
      worksheet['I1'].v = 'Comentarios';
      worksheet['J1'].v = 'Cuenta bancaria';
      worksheet['K1'].v = 'Importe declaración';
      worksheet['L1'].v = 'Individual o conjunta';
  
      const wscols = [
        { wch: 20 }, // Modelo
        { wch: 15 }, // Cod.
        { wch: 15 }, // App Code
        { wch: 35 }, // Cliente
        { wch: 20 }, // Presentación
        { wch: 5 }, // Fase
        { wch: 25 }, // Responsable
        { wch: 20 }, // Ejecutor
        { wch: 10 }, // Comentarios
        { wch: 30 }, // Cuenta bancaria
        { wch: 18 }, // Importe declaración
        { wch: 20 }, // Individual o conjunta
      ];
      worksheet['!cols'] = wscols;
  
      for (let col = 0; col < 12; col++) {
        const cell = worksheet[XLSX.utils.encode_cell({ r: 0, c: col })];
        if (cell) {
          cell.s = {
            font: { bold: true },
            fill: { fgColor: { rgb: 'FFFF00' } },
            alignment: { horizontal: 'center' },
          };
        }
      }
  
      const workbook: XLSX.WorkBook = {
        Sheets: { 'Declaraciones': worksheet },
        SheetNames: ['Declaraciones'],
      };
  
      const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  
      this.saveAsExcelFile(excelBuffer);
    }
  
    private saveAsExcelFile(buffer: any): void {
      const blob: Blob = new Blob([buffer], {
        type: 'application/octet-stream',
      });
      const date = new Date().toISOString().replace(/[-:.]/g, '-').split('T')[0];
      saveAs(blob, `declaraciones_${date}.xlsx`);
    }
}
